import React, { useState, useEffect, useContext } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import MaterialDataGrid from '../../components/MaterialDataGrid'
import MaterialTypography from '../../components/MaterialTypography'
import { AppBar, Badge, Card, CardHeader, Stack, styled, Tab, Tabs } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import MaterialButton from '../../components/MaterialButton'
import AddIcon from '@mui/icons-material/Add';
import BASEURL from '../Utils/Baseurl';
import axios from 'axios';
import MaterialBox from '../../components/MaterialBox'
import breakpoints from '../../assest/theme/base/breakpoints'
import UserDetailsContext from '../../context/auth'

//CSS for material UI Badge
const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        right: -1,
        top: -6,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}));

const EmployeeManagement = () => {

    const navigate = useNavigate()
    const { user,AccessData,setEmpSubmit } = useContext(UserDetailsContext);

    const [pageState, setPageState] = useState({
        loading: false,
        error: false,
        message: "",
        state: 'init'
    })
    const [userDetails, setUserDetails] = useState({
        department: "",
        designation: "",
        employeeType: ""
    });

    const [tabsOrientation, setTabsOrientation] = useState("horizontal"); //Used to store the orientation of the tabs
    const [tabValue, setTabValue] = useState(0); //Used to store current selected tab
    const [employeeList, setEmployeeList] = useState([])
    const [tabs, setTabs] = useState([
        // {
        //     id: "all",
        //     name: "All",
        //     count: 1,
        // },
        {
            id: "employee",
            name: "Employee",
            count: 0,
        },
        {
            id: "manager",
            name: "Manager",
            count: 2
        }]) // Used to show tabs name and passing id to database

    

    useEffect(() => {
        onEmployeeeSubmit();
    }, []);

    useEffect(() => {
        // A function that sets the orientation state of the tabs.
        function handleTabsOrientation() {
            return window.innerWidth < breakpoints.values.sm
                ? setTabsOrientation("vertical")
                : setTabsOrientation("horizontal");
        }
        /** 
         The event listener that's calling the handleTabsOrientation function when resizing the window.
        */
        window.addEventListener("resize", handleTabsOrientation);
        // Call the handleTabsOrientation function to set the state with the initial value.
        handleTabsOrientation();
        // Remove event listener on cleanup
        return () => window.removeEventListener("resize", handleTabsOrientation);
    }, [tabsOrientation]);

    function notificationsLabel(badgeContent) {
        if (badgeContent === 0) {
            return 'no notifications';
        }
        if (badgeContent > 99) {
            return 'more than 99 notifications';
        }
        return `${badgeContent} notifications`;
    }

    const employeeListTable = {
        columns: [
            {
                field: "empid",
                headerName: "Employee Id",
                width: 150,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "firstName",
                headerName: "First Name",
                width: 150,
                editable: false,
                disableColumnMenu: true,
                sortable: true,
            },
            {
                field: "contactNumber",
                headerName: "Contact Number",
                width: 150,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "role",
                headerName: "Role",
                width: 150,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "department",
                headerName: "Department",
                width: 150,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            {
                field: "designation",
                headerName: "Designation",
                width: 150,
                disableColumnMenu: true,
                editable: false,
                sortable: true,
            },
            // {
            //     field: "teamleader",
            //     headerName: "Team leader",
            //     width: 150,
            //     disableColumnMenu: true,
            //     editable: false,
            //     sortable: true,
            // },
            // {
            //     field: "employeeType",
            //     headerName: "Employee Type",
            //     width: 150,
            //     disableColumnMenu: true,
            //     editable: false,
            //     sortable: true,
            // },
        ],

        rows: employeeList.map((performance) => (
         
            {
                id:performance.id,
                empid: performance?.empid,
                firstName: performance.firstName  ? performance.firstName?.charAt(0).toUpperCase() +
                performance.firstName?.slice(1)
              : "",
                contactNumber: performance?.contactNumber,
                role: performance.role?.role,
                department: performance?.department,
                designation: performance?.designation,
               
            }
        )
    )
    }

    const handleNewEmployee = () => {
        setEmpSubmit(false)

        navigate('/employee-management/add-employee')
    }

    const onEmployeeListClick = (e) => {
        console.log('eeeee:',e);
        setEmpSubmit(true)
        console.log('onEmployeeListClick:', e?.id, e)
        if (e?.id) {
            // navigate(`/employee-management/viewscreen?id=${e?.id}`)
            navigate(`/employee-management/add-employee?id=${e?.id}`)
        }
    }


    const onEmployeeeSubmit = async () => {
        const query = `query{
        allUsersDetail{
        id
        lastLogin
        username
        firstName
        lastName
        isActive
        dateJoined
        email
        salutation
        dateOfBirth
        contactNumber
        emergencyContact
        gender
        employeeType
        lastUpdate
        department
        designation
        empid
        teamleader 
        grade
        role{
        role
        }
        }}`;

        try {
            setPageState({ ...pageState, loading: true });

            const response = await axios.post(BASEURL, {
                query: query
            }, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            const userDetails = sessionStorage.getItem('user')
            const getDetails = JSON.parse(userDetails)
            setUserDetails({
                department: user?.department || getDetails.department || "",
                designation: user?.designation || getDetails.designation || "",
                employeeType: user?.employeeType || getDetails.employeeType || ""
            })

            // Extract Employee data from the response
            const EmpList = response.data.data.allUsersDetail;
            console.log('EmpList:',EmpList);

            let filterdata = EmpList.filter((val)=> val.empid != "")
            console.log('filterdata:',filterdata);
            
            
            setEmployeeList(filterdata);
            setPageState({ ...pageState, loading: false, state: 'success' });
        } catch (error) {
            console.error('ResponseError:', error);
            setPageState({ ...pageState, loading: false, error: true, message: error.message });
        }
    };

    console.log("employeeList:",employeeList);
    

    const handleSetTabValue = (event, newValue) => {
        setTabValue(newValue)
    }

    return (
        <DashboardLayout>
            <Card >
                <CardHeader title={(
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                Employee Management List
                            </MaterialTypography>
                            {/* <MaterialTypography variant="caption" color="text">
                                List of employee that you can get details of employee.
                            </MaterialTypography> */}
                        </Stack>

                        {/* <MaterialBox display="flex" justifyContent={{ md: "flex-end" }} alignItems="center" width="60%">
                            <MaterialBox width="80%">
                                <AppBar position="static" >
                                    <Tabs
                                        orientation={tabsOrientation}
                                        value={tabValue}
                                        onChange={handleSetTabValue}
                                        sx={{ backgroundColor: "transparent" }}
                                    >
                                        {tabs.map(tab => (
                                            <Tab label={tab.name} icon={<StyledBadge  color="error" />} iconPosition="end"
                                            />
                                        ))}
                                    </Tabs>
                                </AppBar>
                            </MaterialBox>
                        </MaterialBox> */}
                        {AccessData && Array.isArray(AccessData) && AccessData.some(item => item.component === 'AddEmployee' && item.can_access)&& (

                        <MaterialButton
                            variant="gradient"
                            color="dark"
                            size="small"
                            startIcon={<AddIcon />}
                            onClick={() => handleNewEmployee()}
                        >
                            Employee
                        </MaterialButton>
                        )}
                    </Stack>
                )} />
                <MaterialDataGrid
                     customHeight={500}
                    rows={employeeListTable.rows}
                    columns={employeeListTable.columns}
                    checkboxSelection={false}
                    isSelectable={true}
                    onRowClick={onEmployeeListClick}
                    loading={pageState.loading}
                    localeText={{
                        noRowsLabel: (
                            <Stack direction="column" alignItems="center" justifyContent="center" spacing={1}>
                                <MaterialTypography variant="body2" fontWeight="medium" color="text">
                                    No employee found
                                </MaterialTypography>
                                <MaterialTypography variant="caption" color="text">
                                    You have not yet add any employee details. Click on the "Add Employee" button to start adding employee details.
                                </MaterialTypography>
                            </Stack>
                        )
                    }}
                />
            </Card>
        </DashboardLayout>
    )
}

export default EmployeeManagement
